import * as tslib_1 from "tslib";
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { logMountingPerformance } from 'owa-analytics';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import Droppable from 'owa-dnd/lib/components/Droppable';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import { favoritesStore } from 'owa-favorites';
import { IsGroupsEnabled } from 'owa-group-feature-flags';
import { GroupListTree } from 'owa-group-left-nav-mail';
import { Favorites } from 'owa-mail-favorites-view';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import setIsDraggedOverState from 'owa-mail-folder-store/lib/actions/setIsDraggedOverState';
import { default as viewStateStore } from 'owa-mail-folder-store/lib/store/store';
import { MailFolderTreesParentContainer } from 'owa-mail-folder-tree-container-view';
import commonStrings from 'owa-strings/owa-common-strings';
import getSelectedNodeSelector from 'owa-tree-node/lib/utils/getSelectedNodeSelector';
import { isBrowserEdge, isBrowserIE } from 'owa-user-agent/lib/userAgent';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var classNames = require('classnames/bind');
var styles = require('./FolderPane.scss');
var FolderPane = /** @class */ (function (_super) {
    tslib_1.__extends(FolderPane, _super);
    function FolderPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isIEOrEdge = isBrowserEdge() || isBrowserIE();
        _this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        _this.onDragOver = function (dragInfo) {
            setIsDraggedOverState(true);
        };
        _this.onDragLeave = function (dragInfo) {
            setIsDraggedOverState(false);
        };
        _this.onDrop = function (dragInfo) {
            // NOOP
        };
        return _this;
    }
    FolderPane.prototype.render = function () {
        var _a = this.props, withContextMenuFolderId = _a.withContextMenuFolderId, folderTextFieldViewState = _a.folderTextFieldViewState;
        var containerClassNames = classNames(styles.container, this.isIEOrEdge && styles.isIEOrEdge, // handle auto hiding overlay scrollbar in IE using -ms-autohiding-scrollbar
        this.isFirefox && styles.isFirefox, // show persistent scrollbar in Firefox since it does not support overlay scrollbar
        this.props.isDraggedOver ? styles.showScrollbar : styles.hideScrollbar, // show auto hiding scrollbar on hover
        !!withContextMenuFolderId && styles.withContextMenuOpen, // show the scrollbar:auto if context menu is open
        !!folderTextFieldViewState && styles.withNewFolderTextField, // do not show the scrollbar if we have a new text field
        'customScrollBar', 'disableTextSelection');
        /* TODO: OW:16444: [Accessibility] [Folder] We should be able to tab into the regular Folder tree even if the Favorites tree exists */
        return (React.createElement(FocusZone, { key: "folderPane", className: containerClassNames, direction: FocusZoneDirection.vertical, defaultActiveElement: getSelectedNodeSelector() }, this.renderFolderForest()));
    };
    FolderPane.prototype.renderFolderForest = function () {
        var showGroupList = IsGroupsEnabled();
        var showFavoriteList = this.shouldShowFavoriteList();
        // Show the 'Folders' header when either favorites or groups list is shown
        var isFavoriteOrGroupListShown = showFavoriteList || showGroupList;
        var emptyDropViewState = createDropViewState();
        // Must pass bypassActOnDrop as true so that children nodes' canDrop evaluation
        // is not masked by this component's canDrop, which is always true by default
        var bypassActOnDrop = true;
        return (React.createElement(Droppable, { onDragOver: this.onDragOver, onDrop: this.onDrop, onDragLeave: this.onDragLeave, dropViewState: emptyDropViewState, greedy: true, bypassActOnDrop: bypassActOnDrop },
            React.createElement("span", { className: "screenReaderOnly", role: "heading", "aria-level": 2 }, commonStrings.navigationPaneScreenReaderOnlyText),
            showFavoriteList && (React.createElement(Favorites, { key: "favorites", className: styles.leftNavSectionWithSectionHeaders })),
            React.createElement(MailFolderTreesParentContainer, { isFavoriteOrGroupListShown: isFavoriteOrGroupListShown, leftNavStyleWithSectionHeaders: styles.leftNavSectionWithSectionHeaders, leftNavStyleWithNoSectionHeaders: styles.leftNavSectionWithNoSectionHeaders }),
            showGroupList && (React.createElement(GroupListTree, { className: styles.leftNavSectionWithSectionHeaders }))));
    };
    FolderPane.prototype.shouldShowFavoriteList = function () {
        var numOfFavoriteFolders;
        var numOfFavoritePersonas;
        var numOfFavoriteGroups;
        var numOfFavoriteSearches;
        var numOfFavoriteCategories;
        var numOfFavoritePublicFolders;
        if (isControlFeatureEnabled('tri-favorites-roaming')) {
            // When using the heterogeneous favorites API, show the favorites header when
            // there is any favorite folder or group to show
            numOfFavoriteFolders = favoritesStore.outlookFavoriteFolders.size;
            numOfFavoritePersonas = favoritesStore.outlookFavoritePersonas.size;
            numOfFavoriteGroups = favoritesStore.outlookFavoriteGroups.size;
            numOfFavoritePublicFolders = favoritesStore.outlookFavoritePublicFolders.size;
            numOfFavoriteSearches = isMailFeatureEnabled('tri-favoriteSearch')
                ? favoritesStore.outlookFavoriteSearches.size
                : 0;
            numOfFavoriteCategories = isControlFeatureEnabled('tri-categories-advanced')
                ? favoritesStore.outlookFavoriteCategories.size
                : 0;
        }
        else {
            numOfFavoriteFolders = favoritesStore.favoritesFolderNodes.size;
            numOfFavoritePersonas = favoritesStore.favoritesPersonaNodes.size;
            numOfFavoriteGroups = 0;
            numOfFavoriteSearches = isMailFeatureEnabled('tri-favoriteSearch')
                ? favoritesStore.favoriteSearches.size
                : 0;
            numOfFavoriteCategories = isControlFeatureEnabled('tri-categories-advanced')
                ? favoritesStore.favoriteCategories.size
                : 0;
            numOfFavoritePublicFolders = 0;
        }
        return (numOfFavoriteFolders +
            numOfFavoritePersonas +
            numOfFavoriteGroups +
            numOfFavoriteSearches +
            numOfFavoriteCategories +
            numOfFavoritePublicFolders >
            0);
    };
    FolderPane = tslib_1.__decorate([
        reactive({
            withContextMenuFolderId: function () { return viewStateStore.withContextMenuFolderId; },
            folderTextFieldViewState: function () { return viewStateStore.folderTextFieldViewState; },
            isDraggedOver: function () { return viewStateStore.isDraggedOver; },
        }),
        logMountingPerformance('FolderPane')
    ], FolderPane);
    return FolderPane;
}(React.Component));
export default FolderPane;
//# sourceMappingURL=FolderPane.js.map